export default "__VITE_ASSET__a5016b37__"